//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      color: null,
      dark: false
    };
  },
  methods: {
    $ready: function $ready() {// const vm = this;
      // this.$type.ifArray(this.spec.styleClasses, val => {
      //   ["success", "info", "warning", "error"].forEach(color => {
      //     if (val.remove(color)) {
      //       vm.color = color;
      //       vm.dark = true;
      //     }
      //   });
      // });
    },
    buttonSpec: function buttonSpec(item) {
      return Object.assign({}, item, {
        view: "button-v1",
        styleClasses: ["text"]
      });
    }
  }
};